import { useState } from "react"
import LeftDrawer from "./components/drawer/LeftDrawer"
import Footer from "./components/footer/Footer"
import Navbar from "./components/navbar/Navbar"
import "./SuvaiWrapper.scss"
const SuvaiWrapper = ({ children }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false)

    return (
        <div className="SuvaiWrapper">
            <LeftDrawer
                isOpen={isMenuOpen}
                setIsOpen={setIsMenuOpen} />
            <Navbar
                setIsMenuOpen={setIsMenuOpen} />
            {children}
            <Footer />
        </div>
    )
}
export default SuvaiWrapper